import { defineStore } from 'pinia'
import { StoreId } from '~/store'
import {
  CurrentForm,
  LoginState,
  RequestCodeState,
} from '~/store/login/login.types'

export const useLoginStore = defineStore({
  id: StoreId.LOGIN,
  state: (): LoginState => {
    return {
      phone: '',
      currentForm: CurrentForm.REQUEST_CODE,
      actions: {
        requestCode: {
          disabled: false,
          timer: 0,
          inProgress: false,
        },
      },
    }
  },
  actions: {
    startRequestCodeTimer(timer: number) {
      if (timer === 0) return

      this.actions.requestCode = {
        ...this.actions.requestCode,
        disabled: true,
        timer,
      }

      const intervalId = setInterval(() => {
        const requestCodeTimer = this.actions.requestCode.timer - 1

        this.actions.requestCode.timer = requestCodeTimer

        if (requestCodeTimer === 0) {
          this.actions.requestCode.disabled = false
          clearInterval(intervalId)
        }
      }, 1000)
    },
    changeCurrentForm(formName: CurrentForm) {
      this.currentForm = formName
    },
    setPhone(phone: string) {
      this.phone = phone
    },
    setRequestCodeState(requestCodeState: Partial<RequestCodeState>) {
      this.actions.requestCode = {
        ...this.actions.requestCode,
        ...requestCodeState,
      }
    },
    clearState() {
      this.phone = ''
      this.currentForm = CurrentForm.REQUEST_CODE
    },
  },
  getters: {
    getPhoneWithoutMask:
      ({ phone }) =>
      (code: number) => {
        const phoneWithoutMask = phone.replace(/[^\d]/g, '')

        return `${code}${phoneWithoutMask}`
      },
  },
})
